exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".collection-hero-buttons{display:flex;flex-flow:row wrap;justify-content:flex-end}.collection-hero-buttons__privacy{align-items:center;background-color:rgba(0,0,0,0.5);border-radius:8px;display:flex;height:40px;justify-content:center;margin-bottom:5px;max-width:100px;min-width:36px;outline:none;padding:0 10px;width:100%}.collection-hero-buttons__actions{align-items:center;background-color:rgba(0,0,0,0.5);border-radius:8px;display:flex;flex-flow:row;height:40px;justify-content:space-around;margin-bottom:5px;margin-left:5px}.collection-hero-buttons__action{margin-left:3px}\n", ""]);

// exports
exports.locals = {
	"collection-hero-buttons": "collection-hero-buttons",
	"collection-hero-buttons__privacy": "collection-hero-buttons__privacy",
	"collection-hero-buttons__actions": "collection-hero-buttons__actions",
	"collection-hero-buttons__action": "collection-hero-buttons__action"
};